export const prepareData = (data) => {
  const dataWithToggle = JSON.parse(JSON.stringify(data))
  Object.keys(dataWithToggle).forEach((category) => {
    dataWithToggle[category].isOpen = false
  })
  return dataWithToggle
}
